
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fpm",
      function () {
        return require("private-next-pages/fpm/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fpm"])
      });
    }
  